// Exporting actions as constants to minimize errors:

export const ADD_INGREDIENT = 'ADD_INGREDIENT';
export const REMOVE_INGREDIENT = 'REMOVE_INGREDIENT';



// WEBPACK FOOTER //
// ./src/store/actions.js